import React, {Component} from "react";
import Toggle from 'react-toggle';
import * as PropTypes from "prop-types";

class MyToggle extends Component {

    constructor(props) {
        super(props);
        this.state = {
            checked: props.checked,
            disabled: props.disabled
        }
    }

    onChange() {
        if (this.state.disabled === true) {
            return;
        }

        this.setState({
            checked: !this.state.checked
        }, () => {
            if (this.props.onChange) {
                this.props.onChange(this);
            }
        });
    }

    render() {
        return (
            <Toggle {...this.props}
                    onChange={this.onChange.bind(this)}
                    checked={this.state.checked}
                    disabled={this.state.disabled}
            />
        )
    }

}

MyToggle.defaultProps = {
    checked: false,
    disabled: false,
};

MyToggle.propTypes = {
    required: PropTypes.bool,
    checked: PropTypes.bool,
    disabled: PropTypes.bool,
    onChange: PropTypes.func,
    className: PropTypes.string,
    name: PropTypes.string,
    value: PropTypes.string,
    id: PropTypes.string,
    'aria-labelledby': PropTypes.string,
    'aria-label': PropTypes.string,
};

export default MyToggle;
